import { getBytes } from "@/ui-kit/utilities";

export const DEFAULT_FILE_MAX_COUNT = 5;
export const DEFAULT_FILE_MAX_SIZE = getBytes({ value: 1, unit: "megabyte" });
